import React, { memo } from 'react';
import PropTypes from 'prop-types';

const StepButton = ({
    label,
    step,
    value,
    setValue,
    classNames: { button, buttonContent },
}) => (
    <button
        className={`${button} m2g-touchable`}
        onClick={() => setValue(value + step)}
        type="button"
    >
        <div className={buttonContent}>{label}</div>
    </button>
);

StepButton.defaultProps = {
    classNames: {
        button: 'm2g-step-button',
        buttonContent: 'm2g-step-button-content',
    },
};

StepButton.propTypes = {
    label: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    setValue: PropTypes.func.isRequired,
    classNames: PropTypes.shape({
        button: PropTypes.string,
        buttonContent: PropTypes.string,
    }),
};

export const LessButton = memo(props =>
    StepButton({
        step: -1,
        ...props,
    })
);
LessButton.defaultProps = {
    label: '−',
};

export const MoreButton = memo(props =>
    StepButton({
        step: 1,
        ...props,
    })
);
MoreButton.defaultProps = {
    label: '+',
};

export default memo(StepButton);
